import React, { Component } from 'react';
import { func, bool, shape, string, number } from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Radium from 'radium';
import { reducerAccumulator } from '@widergy/web-utils/lib/array';

import { accountPropTypes } from 'redux/accountHandlers';
import { actionCreators as paymentActions } from 'redux/paymentHandlers';
import { appConfig, DOCUMENT } from 'config/customization';

import AccountPaymentDetails from './layout';

class AccountPaymentDetailsContainer extends Component {
  state = { checkAll: false, list: [], accountTotalAmount: 0 };

  componentDidMount = () => {
    if (this.props.checkedAccount === this.props.account.client_number) {
      this.setState({ list: this.props.account.debts, checkAll: true }, () =>
        this.calculateTotalAmount(this.props.account.client_number, this.state.list)
      );
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      this.props.checkedAccount !== nextProps.checkedAccount &&
      nextProps.checkedAccount !== this.props.account.client_number
    ) {
      this.setState({ checkAll: false, list: [], accountTotalAmount: 0 });
    }
    if (
      this.props.checkedAccount !== nextProps.checkedAccount &&
      nextProps.checkedAccount === this.props.account.client_number
    ) {
      this.setState({ list: nextProps.account.debts, checkAll: true }, () =>
        this.calculateTotalAmount(nextProps.account.client_number, this.state.list)
      );
    }
  };

  calculateTotalAmount = (clientNumber, values) => {
    this.props.setTotalAmount(clientNumber, values);
    const totalAmount = values
      .map(item => item.balance || item.amount || item.value.balance || item.value.amount)
      .reduce(reducerAccumulator, 0);
    this.setState({ accountTotalAmount: totalAmount });
  };

  handleDownloadAllPaymentDocuments = () =>
    this.props.dispatch(paymentActions.getMultiplePaymentDocuments(this.props.account.client_number));

  handleDownloadPaymentDocument = paymentDocument =>
    this.props.dispatch(
      appConfig.payments.paymentDocumentDownloadOnPDF
        ? paymentActions.getPaymentDocumentPDF(this.props.account.client_number, paymentDocument.external_id)
        : paymentActions.getPaymentDocument(
            this.props.account.client_number,
            this.props.userInfo,
            paymentDocument.external_id,
            this.props.isPublic
          )
    );

  handleOnChange = item => {
    this.props.handleChangeCheckedAccount(this.props.account);
    const newValues =
      this.state.list.findIndex(
        elem => (elem.external_id || elem.value.external_id) === (item.external_id || item.value.external_id)
      ) === -1
        ? [...this.state.list, item]
        : this.state.list.filter(
            elem =>
              (elem.external_id || elem.value.external_id) !== (item.external_id || item.value.external_id)
          );
    this.setState({
      checkAll: newValues.length === this.props.account.debts.length,
      list: newValues
    });
    this.calculateTotalAmount(this.props.account.client_number, newValues);
  };

  handleCheckAll = () => {
    this.props.handleChangeCheckedAccount(this.props.account);
    const list = this.state.checkAll ? [] : this.props.account.debts;
    this.setState(prevState => ({
      list,
      checkAll: !prevState.checkAll
    }));
    this.calculateTotalAmount(this.props.account.client_number, list);
  };

  retrieveUnpaidBills = () => {
    const downloadAll = {
      downloadable:
        this.props.account.debts && this.props.account.debts.some(element => element.downloadable),
      multipleDownload: true
    };
    return this.props.account.debts &&
      this.props.account.debts.length > 0 &&
      appConfig.payments.multipleDownloadRow
      ? [...this.props.account.debts, downloadAll]
      : this.props.account.debts;
  };

  handleOpenPaymentDocumentModal = () => this.props.onOpenPaymentDocumentModal(this.props.account);

  render() {
    return (
      <AccountPaymentDetails
        account={this.props.account}
        rows={this.retrieveUnpaidBills()}
        handleCheckAll={this.handleCheckAll}
        handleOnChange={this.handleOnChange}
        checkAll={this.state.checkAll}
        handleOnPress={this.props.handleOnPress}
        handleAccountPayment={this.props.handleAccountPayment}
        list={this.state.list}
        paymentDocumentUrl={this.props.paymentDocumentUrl}
        multiplePaymentDocumentsUrl={this.props.multiplePaymentDocumentsUrl}
        isOpen={this.props.isOpen}
        onRowsRendered={this.props.onRowsRendered}
        onDownloadAllPaymentDocuments={this.handleDownloadAllPaymentDocuments}
        multiplePaymentDocumentsLoading={this.props.multiplePaymentDocumentsLoading}
        onDownloadPaymentDocument={this.handleDownloadPaymentDocument}
        paymentDocumentLoading={this.props.paymentDocumentLoading}
        accountTotalAmount={this.state.accountTotalAmount}
        onOpenPaymentDocumentModal={this.handleOpenPaymentDocumentModal}
        isPublic={this.props.isPublic}
      />
    );
  }
}

AccountPaymentDetailsContainer.propTypes = {
  account: accountPropTypes,
  onRowsRendered: func,
  setTotalAmount: func,
  handleOnPress: func,
  isOpen: bool,
  userInfo: shape({
    documentType: string,
    documentNumber: number,
    email: string
  }),
  paymentDocumentUrl: string,
  paymentDocumentLoading: bool,
  multiplePaymentDocumentsUrl: string,
  multiplePaymentDocumentsLoading: bool,
  checkedAccount: string,
  handleAccountPayment: func,
  handleChangeCheckedAccount: func,
  onOpenPaymentDocumentModal: func,
  isPublic: bool
};

const userInformationSelector = createSelector(
  store => store.auth.currentUser,
  currentUser => {
    if (currentUser) {
      if (appConfig.signInMethod === DOCUMENT) {
        return {
          documentType: currentUser.document_type,
          documentNumber: currentUser.document_number
        };
      }
      return { email: currentUser.email };
    }
    return {};
  }
);

const mapStateToProps = store => ({
  paymentDocumentUrl: store.payment.paymentDocument,
  paymentDocumentLoading: store.payment.paymentDocumentLoading,
  multiplePaymentDocumentsUrl: store.payment.multiplePaymentDocuments,
  multiplePaymentDocumentsLoading: store.payment.multiplePaymentDocumentsLoading,
  userInfo: userInformationSelector(store)
});

export default connect(mapStateToProps)(Radium(AccountPaymentDetailsContainer));
